import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';
import Button from '../../components/Common/Button';
import { stringToBoolean } from '../../utilities/conversionUtility';

const ButtonWrapper = styled.div`
  margin-top: 10px;
`;

const MessageWrapper = styled.div`
  text-align: center;
`;

const CreatedBookingPage = (props) => {
  const { settings, subPanelClass, onNewBooking } = props;
  const { style = {}, setting } = settings;
  const t = new Translation(settings);
  const showButton = !stringToBoolean(setting.hide_make_another_booking_button);

  return (
    <div className="widget-container">
      <div className={`${subPanelClass}`} style={{ ...style.body, ...style.boxShadow }}>
        <MessageWrapper>
          {t.key('createdBookingMessage')}
        </MessageWrapper>
        {showButton &&
          <ButtonWrapper>
            <Button
              styled={style.button}
              submit
              onClick={onNewBooking}
            >
              {t.key('makeAnotherBooking')}
            </Button>
          </ButtonWrapper>
        }
      </div>
    </div>
  );
}

export default connect(
  ({ settings }) => ({
    settings: settings,
  })
)(CreatedBookingPage);